import { WidgetConfig } from '../../../models/widget.config';

export class StringWidgetConfig extends WidgetConfig<string> {
  widgetType = 'StringWidget';
  constructor(config: Record<string, any> = {}) {
    super(config);
  }
}
